import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../utils/mock';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="bg-gradient-to-r from-[#1565C0] to-[#0D47A1] text-white px-4 py-2 rounded-full text-sm font-semibold">
              FAQ
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Find answers to common questions about studying abroad, visa processes, and our services.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div 
              key={faq.id}
              className="mb-4 border border-gray-200 rounded-xl overflow-hidden hover:border-[#1565C0] transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors duration-200"
              >
                <span className="text-left font-semibold text-gray-900 text-lg pr-4">
                  {faq.question}
                </span>
                <ChevronDown 
                  size={24} 
                  className={`text-[#1565C0] flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 py-5 bg-gradient-to-br from-gray-50 to-white border-t border-gray-200">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Still Have Questions CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-[#8BC34A]/10 to-[#1565C0]/10 px-8 py-6 rounded-2xl">
            <p className="text-lg text-gray-700 mb-4">
              Still have questions? We're here to help!
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('consultation');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-[#1565C0] font-semibold hover:text-[#FF7043] transition-colors"
            >
              Book a Free Consultation →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
